import QRCode from 'qrcode';

export async function generateQrDataUrl(
  data: string,
  options?: {
    width?: number;
    margin?: number;
    color?: {
      dark?: string;
      light?: string;
    };
  },
): Promise<string> {
  const dataUrl = await QRCode.toDataURL(data, {
    width: options?.width ?? 600,
    margin: options?.margin ?? 2,
    color: {
      dark: options?.color?.dark ?? '#000000',
      light: options?.color?.light ?? '#ffffff',
    },
    errorCorrectionLevel: 'L',
  });
  return dataUrl;
}
